import React, { FC, useState, useEffect, useContext } from 'react';
import { ProfileSection } from './ProfileSection';
import { sessionStore } from 'src/store/sessionStore';
import { useUpdateTrainerProfile } from 'src/api/mutations/useUpdateTrainerProfile';
import { ProfileEditContext } from '../ProfileEditContext';
import './TextSection.scss';
import { ReactComponent as ExperienceLevelIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience-level.svg';

export const TrainingStyleSection: FC = () => {
  const { currentUser } = sessionStore();
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState('');
  const [trainingStyle, setTrainingStyle] = useState(currentUser?.trainingStyle || '');
  const { mutateAsync: updateProfileBackend, isPending } = useUpdateTrainerProfile();

  const { globalEditAction, registerEditState } = useContext(ProfileEditContext);

  useEffect(() => {
    if (globalEditAction.count > 0) {
      if (globalEditAction.type === 'OPEN') {
        setIsEditing(true);
      } else if (globalEditAction.type === 'CLOSE') {
        setIsEditing(false);
      }
    }
  }, [globalEditAction]);

  useEffect(() => {
    registerEditState('trainingStyle', isEditing);
  }, [isEditing, registerEditState]);

  useEffect(() => {
    if (currentUser && !isEditing) {
      setTrainingStyle(currentUser.trainingStyle || '');
    }
  }, [currentUser, isEditing]);

  const handleSave = async () => {
    if (!currentUser) return;

    if (trainingStyle.length > 1000) {
      setError('Training Style must be less than 1000 characters');
      return;
    }

    const trimmedStyle = trainingStyle.trim();
    if (!trimmedStyle) {
      setError('Training Style is required');
      return;
    }
    setError('');
    setTrainingStyle(trimmedStyle);

    try {
      const uid = currentUser?.uid || '';
      await updateProfileBackend({
        uid,
        data: { trainingStyle: trimmedStyle },
      });
      setIsEditing(false);
    } catch (error) {
      console.error(error);
    }
  };

  const viewContent = (
    <div className="text-section-view">
      <div className="icon-wrapper">{<ExperienceLevelIcon />}</div>
      <p>{currentUser?.trainingStyle || 'No training style description provided.'}</p>
    </div>
  );

  const editContent = (
    <div className="text-section-edit">
      <p className="description">{'Explain your training approach and philosophy'}</p>
      <div className="form-group">
        <textarea
          value={trainingStyle}
          maxLength={1000}
          onChange={(e) => {
            setTrainingStyle(e.target.value);
            if (error) setError('');
          }}
          onBlur={(e) => setTrainingStyle(e.target.value.trim())}
          placeholder="I believe in progressive overload and periodization..."
          className={error ? 'error-border' : ''}
        />
        {error && <p className="error-message">{error}</p>}
        <small
          style={{
            color: trainingStyle.length > 1000 ? 'red' : 'rgba(255,255,255,0.4)',
            alignSelf: 'flex-end',
            marginTop: 4,
          }}
        >
          {trainingStyle.length}/1000
        </small>
      </div>
    </div>
  );

  return (
    <ProfileSection
      title="Training Style"
      className="align-items-center career-highlights-centificate-header"
      isEditing={isEditing}
      isSaving={isPending}
      onEditToggle={setIsEditing}
      onSave={handleSave}
      onCancel={() => {
        if (currentUser) {
          setTrainingStyle(currentUser.trainingStyle || '');
          setError('');
        }
      }}
      editContent={editContent}
    >
      {viewContent}
    </ProfileSection>
  );
};
